import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {refundverifys} = api

/**
 * 查找列表
 */
export async function findRefundverifys(params) {
    return request({url:refundverifys, method: 'get', data: params,})
}



// WEBPACK FOOTER //
// ./src/services/refundVerify.js